<template lang="html">
  <section :id="id" class="custom-display-element-expand-item">
    <div v-if="memberProp.custom" class="custom-prop-name">
      <input
        class="text-input"
        v-model.trim="memberProp.name"
        @keyup.stop="onInputChange"
      />
    </div>
    <div v-else class="member-name">
      {{ memberName }}
    </div>
    <expressions
      :id="`prop-expression-${memberProp.name}`"
      :data-elements="allSources"
      :data-type="dataType"
      :selected-source="dataSource"
      :initial-expression="initialExpression"
      :content-type="appType"
      @on-expression-field-valid="onConfigExpressionValid"
    />
    <svg
      v-if="memberProp.custom"
      tabindex="0"
      @keydown.enter.stop="toggleConfirmModal"
      @click.stop="toggleConfirmModal"
    >
      <use xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#delete" />
    </svg>
    <simple-modal
      :show="displaySimpleModal"
      :message="getMessageText(messages.ARE_YOU_SURE)"
      :cancel-text="getMessageText(messages.CANCEL)"
      :ok-text="getMessageText(messages.OK)"
      @on-simple-modal-cancel="onCancelSimpleModal"
      @on-simple-modal-ok="onConfirmSimpleModal"
    />
  </section>
</template>

<script lang="js">
  import distributionChannelUtil from "@/utils/distribution-channel-util";
  import SimpleModal from "@/views/drag-drop-pages/components/modal/SimpleModal";
  import Expressions from "@/components/Expressions";

  export default  {
    name: "custom-display-element-expand-item",
    components: {
      SimpleModal,
      Expressions
    },
    props: {
      id: String,
      memberProp: Object,
      translations: {
        type: Object,
        default: function() {
          return {};
        }
      },
      dataSource: Object,
      allSources: Object,
      initialExpression: Object,
      appType: String
    },
    data () {
      return {
        displaySimpleModal: false
      }
    },
    computed: {
      messages() {
        return this.$store.state.messages;
      },
      dataType() {
        return distributionChannelUtil.getDataType(this.memberProp);
      },
      memberName() {
        return distributionChannelUtil.memberMessageTranslation(this.translations, this.memberProp);
      }
    },
    methods: {
      onCancelSimpleModal() {
        this.toggleConfirmModal();
      },
      onConfirmSimpleModal() {
        this.toggleConfirmModal();
        this.$emit("on-member-field-remove", {member: this.memberProp});
      },
      toggleConfirmModal() {
        this.displaySimpleModal = !this.displaySimpleModal;
      },
      onConfigExpressionValid(ctx) {
        this.confExpression = ctx.status? ctx.confExpression : null;
        this.memberProp.type.text = "";
        if(this.confExpression) {
          this.memberProp.type.text = this.confExpression.dataType;
        }
        this.emitEvent();
      },
      onInputChange() {
        // for custom field property
        this.emitEvent();
      },
      emitEvent() {
        this.$emit("on-member-field-updated", {id: this.id, memberProp: this.memberProp, expression: this.confExpression});
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  .custom-display-element-expand-item {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    padding: 0.3rem 0;
    .member-name {
      width: 25%;
      word-break: break-word;
    }
    .expression {
      width: stretch;
    }
    svg {
      width: 1.5rem;
      height: 1.5rem;
      cursor: pointer;
      fill: var(--BUTTON_DESTRUCTIVE_BKGND, #a61a14);
    }
    .custom-prop-name {
      width: 20%;
      .text-input {
        @include mixin-text-input;
      }
    }
  }
</style>
